// extracted by extract-css-chunks-webpack-plugin
module.exports = {"third-party-service":"_2-rUF","chat":"_10hns"};